// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './telegram-users-api';

export const useListTelegramUsers: typeof hookExports.useListTelegramUsers =
  hookExports.useListTelegramUsers;
export const useLazyListTelegramUsers: typeof hookExports.useLazyListTelegramUsers =
  hookExports.useLazyListTelegramUsers;
